export default {"src":"/_next/static/media/report.479d16f4.svg","height":213,"width":190,"blurWidth":0,"blurHeight":0};